/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  fetchWorkflowInboxes(inboxId) {
    return axios.get(`${this.url}/${inboxId}/workflow_inboxes`);
  }

  createWorkflowInbox(inboxId, workflowInbox) {
    return axios.post(`${this.url}/${inboxId}/workflow_inboxes`, {
      workflow_inbox: workflowInbox,
    });
  }

  updateWorkflowInbox(inboxId, workflowInboxId, workflowInbox) {
    return axios.patch(
      `${this.url}/${inboxId}/workflow_inboxes/${workflowInboxId}`,
      {
        workflow_inbox: workflowInbox,
      }
    );
  }

  deleteWorkflowInbox(inboxId, workflowInboxId) {
    return axios.delete(
      `${this.url}/${inboxId}/workflow_inboxes/${workflowInboxId}`
    );
  }
}

export default new Inboxes();
